import $ from './main';

window.$ = $;

// console.log('donate.js loaded');
// check which tab we need to present? is the second block in the page?
// if so, we shoulastDay show this... before the amount one one..
let $formContainer = null;

const disabledDays = () => {
  const today = new Date();

  let d1 = new Date(today);
  d1.setDate(d1.getDate() + 1);
  const day1 = d1.getDate() + '-' + (d1.getMonth() + 1) + '-' + d1.getFullYear();

  let d2 = new Date(today);
  d2.setDate(d2.getDate() + 2);
  const day2 = d2.getDate() + '-' + (d2.getMonth() + 1) + '-' + d2.getFullYear();

  let d3 = new Date(today);
  d3.setDate(d3.getDate() + 3);
  const day3 = d3.getDate() + '-' + (d3.getMonth() + 1) + '-' + d3.getFullYear();

  return [day1, day2, day3];
}

const initDatePicker = () => {
  const width = $(window).width();
  $formContainer.find('.js-datepicker').each(function () {
    const $this = $(this);
    if (width > 1) {
      $this.attr('type', 'text');
      $this.datepicker({
        autoclose: true,
        clearBtn: true,
        format: 'yyyy-mm-dd',
        container: $(this).parent('li'),
        startDate: $this.data('startdate'),
        endDate: $this.data('enddate'),
        beforeShowDay: function (d) {
          let date = d.getDate() + '-' + (d.getMonth() + 1) + '-' + d.getFullYear();
          if (disabledDays().indexOf(date) != -1) {
            return false;
          } else {
            return true;
          }
        }
      });
    } else {
      $this.attr('type', 'date');
    }
  });
};

const scrollToDonationFormContainer = () => {
  const donationForm = document.querySelector('.donation-widget-container')
    || document.querySelector('#donation-form-container')
    || document.querySelector('.donate-form-area');
  if (!donationForm) {
    return;
  }

  const header = document.querySelector('.js-site-header');
  const headerOffset = window.innerWidth < 1000 && header ? header.clientHeight : 0;
  const formPosition = donationForm.getBoundingClientRect().top + window.pageYOffset;

  window.scrollTo({
    top: Math.max(formPosition - headerOffset, 0),
    behavior: 'smooth',
  });
};

const validateAmountAndFrequency = (element, callback) => {
  if(callback === frequencyChangeUpdate) {
    handleDonationAmount(null);
  }

  const $element = $(element);
  const $form = $element.closest('.js-donate-form');

  $('body').addClass('submit');
  
  $.ajax({
    url: $form.attr('action'),
    method: $form.attr('method'),
    data: $form.serialize(),
    headers: {
      'HX-Request': window.inlineDonation
    },
    success: (html) => {
      const $responseField = $(html).find('.js-donate-form-elements');
      if ($responseField.length > 0) {
        // Only replace the form elements, not the entire form
        $form.find('.js-donate-form-elements').replaceWith($responseField);
        
        // Reinitialize HTMX on the new form elements
        // if(window.inlineDonation) {
        //   window.htmx.process(document.querySelector('.js-donate-form'));
        // }
        
        callback($form, $responseField);
      }

      // Only scroll when advancing to contact details (not on first load or frequency change).
      if (callback === donateChangeUpdate) {
        scrollToDonationFormContainer();
      }
    },
    complete: () => {
      $('body').removeClass('submit');
    },
  });
};

// const checkFielastDaysForMobile = ($element) => {
//   if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
//     $('.js-donation-form-start-date').addClass('visuallyhidden');
//
//     // initAvailableDates();
//     // $('.js-startdate').val("2022-05-02");
//     if ($element.val() == '1') {
//       $('.js-donation-form-mobile').removeClass('visuallyhidden');
//     } else {
//       $('.js-donation-form-mobile').addClass('visuallyhidden');
//     }
//   }
// };

const clearDropdown = (id) => {
  var select = document.getElementById(id);
  var length = select.options.length;
  for (let i = length - 1; i >= 0; i--) {
    select.options[i] = null;
  }
};

// const handleChangeStartDate = (isMonth = false, isYear = false) => {
//   let day = $('.js-start-day').val();
//   let month = $('.js-start-month').val();
//   let year = $('.js-start-year').val();
//
//   let dates = availableDates();
//
//   if (isMonth) {
//     let newDates = [];
//     dates.forEach(date => {
//       if (date.getMonth() == month) {
//         newDates.push(date);
//       }
//     });
//
//     clearDropdown('js-start-day');
//     let selectDay = document.getElementById('js-start-day');
//     for (let i = 0; i <= newDates.length - 1; i++) {
//       let date = new Date(newDates[i]);
//       let option = document.createElement('option');
//       option.text = date.getDate();
//       option.value = date.getDate();
//       selectDay.add(option);
//     }
//
//     let date = new Date(newDates[0]);
//     day = date.getDate();
//   }
//
//   if (isYear) {
//     //
//   }
//
//   month = parseInt(month) + 1;
//   let startDate = year + '-' + month + '-' + day;
//   $('.js-startdate').val(startDate);
// };

const availableDates = () => {
  const today = new Date();

  let year = today.getFullYear();
  let month = today.getMonth();
  let date = new Date(today);
  date = date.getDate() + 4;

  let dates = [];

  for(let i = 0; i < 60; i++) {
    let d = new Date(year, month, date + i);
    dates.push(d);
  }

  return dates;
};

// const initAvailableDates = () => {
//   const dates = availableDates();
//
//   let years = [];
//   dates.forEach(date => {
//     let year = date.getFullYear();
//     if (!years.includes(year)) {
//       years.push(year);
//     }
//   });
//
//   let months = [];
//   dates.forEach(date => {
//     let month = date.getMonth();
//     if (!months.includes(month)) {
//       months.push(month);
//     }
//   });
//
//   const lastday = () => {
//     const today = new Date();
//     return new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
//   };
//
//   const firstday = dates[0].getDate();
//
//   let days = [];
//   for(let i = firstday; i <= lastday(); i++) {
//     days.push(i)
//   }
//
//   let selectYear = document.getElementById('js-start-year');
//   years.forEach(year => {
//     let option = document.createElement('option');
//     option.text = year;
//     option.value = year;
//     selectYear.add(option);
//   });
//
//   const month_names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//
//   let selectMonth = document.getElementById('js-start-month');
//   months.forEach(month => {
//     let option = document.createElement('option');
//     option.text = month_names[month];
//     option.value = month;
//     selectMonth.add(option);
//   });
//
//   let selectDay = document.getElementById('js-start-day');
//   days.forEach(day => {
//     let option = document.createElement('option');
//     option.text = day;
//     option.value = day;
//     selectDay.add(option);
//   });
//
//   const d = new Date();
//   const day = d.getDate();
//   const month = d.getMonth() + 1;
//   const year = d.getFullYear();
//
//   const dayStart = day + 4;
//
//   const startDate = year + '-' + month + '-' + dayStart;
//
//   $('.js-startdate').val(startDate);
// };

const frequencyChangeUpdate = () => {
  $('.validationErrors').hide();
  $('.js-donate-step-amount').removeClass('visuallyhidden');
  $('.js-donate-step-details').addClass('visuallyhidden');
  $('.js-donate-form-step .active').removeClass('active');
  $('.js-donate-form-step__amount').addClass('active');
  
  const monthlyRadio = document.getElementById('donation_donationType_1');
  if (monthlyRadio && monthlyRadio.checked) {
    $('body').addClass('is-regular-donation');
  } else {
    $('body').removeClass('is-regular-donation');
  }
  handleDonationAmount(null);
};

const donateChangeUpdate = () => {
  // 1. if we have validation errors in the first step of the form, then we need to select this
  // 2. otherwise we can progress to the second page.

  if ($('.js-donate-step-amount .validationErrors').length > 0) {
    $('.js-donate-step-amount').removeClass('visuallyhidden');
    $('.js-donate-step-details').addClass('visuallyhidden');
    $('.js-donate-form-step .active').removeClass('active');
    $('.js-donate-form-step__amount').addClass('active');
  } else if ($('#donation_donationDetails').length > 0) {
    // we need to create query param to identify this step
    if(!window.inlineDonation) {
      changeQueryParam("donate-step", "details");
    }
    $('.js-donate-step-amount').addClass('visuallyhidden');
    $('.js-donate-form-step .active').removeClass('active');
    $('.js-donate-form-step__details').addClass('active');
    $('.validationErrors').hide();
  }
  $('.donate-story').hide();
};

// take us back to the first step of the form
const handleBackClick = () => {
  // we need to add URL param or replace it
  if(!window.inlineDonation) {
    changeQueryParam("donate-step", "amount");
  }

  $('.js-donate-step-amount').removeClass('visuallyhidden');
  $('.js-donate-step-details').addClass('visuallyhidden');
  $('.js-donate-form-step .active').removeClass('active');
  $('.js-donate-form-step__amount').addClass('active');
  $('.donate-story').show();
};

const handleOtherAmountClick = (element) => {
  const $element = $(element);
  $element.addClass('active');
  $($element.attr('href')).addClass('active');

  $('.js-amount-choice').each(function () {
    this.checked = false;
  });

  $('.js-amount-other-value').focus();

  return false;
};

const handleRadioChange = () => {
  // console.log('handleRadioChange');
  const $otherButton = $('.js-amount-other');
  $otherButton.removeClass('active');
  $($otherButton.attr('href')).removeClass('active');
  return false;
};

const handleOrganisationClick = (element) => {
  if (element.checked) {
    const orgTemplate = `
<li class="fielastDay fielastDay--text">
  <label for="donation_organisationName" class="required">Company Name<span class="required" title="This fielastDay is required">*</span></label>
  <input id="donation_organisationName" name="donation[organisationName]" required="required" class="input--txt" type="text" value="">
</li>`;

    $('#donation_isOrganisation').parent().after(orgTemplate);
  } else {
    $('#donation_organisationName').parent().remove();
  }
};

const handleDonationAmount = (id) => {
  let amount;
  if (id === null) {
    const count = $('.donate-description').length - 3;
    const dom = $(`.donate-description:eq(${count})`);
    if(dom.length > 0) {
      amount = dom.attr('id').replace('donate-description-', '');
    }
  } else {
    amount = id.replace('donate-amount-', '');
  }
  
  // need to reslect radio button as well otherwise the description and amount won't match
  $(".js-amount-choice[value='" + amount + "']").prop('checked', true);
  
  const description = $(`#donate-description-${amount}`).val();
  $('.donate-band-note').text(description);
};

const handlePreSelectFrequency = () => {
  const length = $('.js-donate-frequency li').length;
  if (length < 2) {
    $('.js-donate-frequency').parent().hide();
    const firstFrequency = $('.js-donate-frequency li').find('input');
    $(firstFrequency).attr('checked', 'checked');
  }
};

const initTextAreaLimit = (target) => {
  let textLimitRemaining = 240 - $(target).val().length;
  let validationMessage = `<ul class="validationErrors"><li class="form-validation-info">${ textLimitRemaining > 0 ? `${textLimitRemaining} characters remaining` : `<li class="formValidationError">Please add upto 240 characters only</li>` }</li></ul>`;
  $(target).parents(".field--textarea").find('.validationErrors').remove();
  $(target).after(validationMessage);
};

$(document).ready(($) => {
  $formContainer = $('.donate-form').parent();
  // we grab the parent so we can replace the form with any new/updated versions...
  $formContainer.on('change', '.js-donate-frequency input[type=radio]', e => validateAmountAndFrequency(e.target, frequencyChangeUpdate));
  // $formContainer.on('change', '.js-start-day', e => handleChangeStartDate(false, false));
  // $formContainer.on('change', '.js-start-month', e => handleChangeStartDate(true, false));
  // $formContainer.on('change', '.js-start-year', e => handleChangeStartDate(false, true));
  $formContainer.on('click', '.js-donate-step-amount__donate-button', e => validateAmountAndFrequency(e.target, donateChangeUpdate));
  $formContainer.on('click', '.js-donate-step-details__back', e => handleBackClick(e.target));

  $formContainer.on('click', '.js-amount-other', e => handleOtherAmountClick(e.target));
  $formContainer.on('change', '.js-amount-choice', e => handleRadioChange(e.target));
  $formContainer.on('click', '.js-amount-choice', e => handleRadioChange(e.target));

  $formContainer.on('change', '#donation_isOrganisation', e => handleOrganisationClick(e.target));

  let amountChoiceValue = $('.js-amount-choice-value').val();
  if(amountChoiceValue) {
    handleDonationAmount('donate-amount-' + amountChoiceValue);
  } else {
    handleDonationAmount(null);
  }

  $formContainer.on('click', '.button--donate-band-toggle', e => handleDonationAmount(e.target.id));

  handlePreSelectFrequency();

  $formContainer.on('keyup', '#donation_comments', e => initTextAreaLimit(e.target));

  // Initialize HTMX on the form
  // if(typeof htmx !== 'undefined') {
  //   htmx.process(document.querySelector('.js-donate-form'));
  // }

  // Handle query param
  if($(document).find(".js-donate-step-details").length === 0) {
    // we need to add URL param or replace it
    if(!window.inlineDonation) {
      changeQueryParam("donate-step", "amount");
    }
  }

  // we need to select give monthly if this hash in URL
  if(window.location.hash === "#give-monthly") {
    $( ".js-donate-frequency li" ).each(function( index ) {
      if($( this ).text().indexOf("GIVE MONTHLY") >= 0) {
        $(this).find("label").click();
        $('body').addClass('is-regular-donation');
      }
    });
  }

  /** Just for A/B testing **/
  if($("#js-donate-form-area").hasClass("js-give-montly")) {
    $( ".js-donate-frequency li" ).each(function( index ) {
      if($( this ).text().indexOf("GIVE MONTHLY") >= 0) {
        $(this).find("label").click();
      }
    });
  }
});
